import * as locationFilters from '@bingads-webui-campaign-legacy/location-targets/util/filters';
import _ from 'underscore';
import {
  KPLocations,
  LOCATION_COUNTRYCODE_WHITE_LIST,
  LOCATION_TYPE,
} from '@bingads-webui-campaign-react/keyword-planner-shared';
import * as LocationTargetTypes from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetTypes';
// import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { isAllLocationsUnsupported, onlyTire2LangaugesSelected } from './location-util';

// jsdata.Intermediate.getAll('CampaignCriterion')
export const getTargetedLocationInfo = (criterions, permissions) => {
  if (permissions && permissions.dynamic && permissions.dynamic.KeywordPlannerLiteRefactorPhase1) {
    if (_.isEmpty(criterions)) {
      return _.map(KPLocations, location => ({ id: location.id }));
    }

    const includedCriterions = _.where(criterions, {
      Status: 'Active',
      SelectionStatus: LocationTargetTypes.Included,
    });

    const locations = _.map(includedCriterions, (criterion) => {
      const target = criterion.Criterion.LocationCriterion || criterion.Criterion.RadiusCriterion || {};
      return { id: target.LocationId, countryCode: target.CountryCode, locationType: target.LocationType };
    });

    return _.filter(locations, location => !_.isUndefined(location.id) && (_.contains(LOCATION_COUNTRYCODE_WHITE_LIST, location.countryCode)
      || (location.locationType === LOCATION_TYPE.COUNTRY && _.contains(_.map(KPLocations, country => country.id), location.id))));
  }

  const locationsObj = locationFilters.getSupportedLocationIds(criterions, true);

  return {
    locations: locationsObj.items,
    numLocationsTargeted: locationsObj.totalCount,
    countryLocationInfo: locationsObj.countryLocationInfo,
  };
};

export const useSearchBoxStatus = (targetedLocationInfo, languages, permissions) => {
  const status = {
    url: true,
    keywords: true,
  };

  if (permissions && permissions.dynamic && permissions.dynamic.KeywordPlannerLiteRefactorPhase1) {
    return status;
  }

  const allLocationsUnsupported = isAllLocationsUnsupported(targetedLocationInfo);
  if (allLocationsUnsupported) {
    status.url = false;
    status.keywords = false;
  } else if (onlyTire2LangaugesSelected(targetedLocationInfo.locations, languages, true)) {
    status.keywords = false;
  }

  return status;
};

